import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { Layout } from "@/components/site/Layout";
import HomePage from "@/pages/HomePage";

const ServicePage = lazy(() => import("@/pages/ServicePage"));
const ServicesPage = lazy(() => import("@/pages/ServicesPage"));
const AboutPage = lazy(() => import("@/pages/AboutPage"));
const ContactPage = lazy(() => import("@/pages/ContactPage"));
const LegalPage = lazy(() => import("@/pages/LegalPage"));
const NotFoundPage = lazy(() => import("@/pages/NotFoundPage"));
const AdminLogin = lazy(() => import("@/pages/admin/AdminLogin"));
const AdminShell = lazy(() => import("@/pages/admin/AdminShell"));
const AdminInbox = lazy(() => import("@/pages/admin/AdminInbox"));
const AdminPosts = lazy(() => import("@/pages/admin/AdminPosts"));
const AdminPostEditor = lazy(() => import("@/pages/admin/AdminPostEditor"));
const AdminReviews = lazy(() => import("@/pages/admin/AdminReviews"));
const BlogPage = lazy(() => import("@/pages/BlogPage"));
const PostPage = lazy(() => import("@/pages/PostPage"));
const FreeConsultationPage = lazy(() => import("@/pages/FreeConsultationPage"));
const EligibilityPage = lazy(() => import("@/pages/EligibilityPage"));

const Fallback = () => <div className="min-h-[60vh]" aria-busy="true" />;

function App() {
  return (
    <BrowserRouter>
      <Suspense fallback={<Fallback />}>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/services/:slug" element={<ServicePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/free-consultation" element={<FreeConsultationPage />} />
            <Route path="/eligibility-check" element={<EligibilityPage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:slug" element={<PostPage />} />
            <Route path="/privacy-policy" element={<LegalPage kind="privacy" />} />
            <Route path="/terms-of-service" element={<LegalPage kind="terms" />} />
            <Route path="/disclaimer" element={<LegalPage kind="disclaimer" />} />
            <Route path="*" element={<NotFoundPage />} />
          </Route>
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminShell />}>
            <Route index element={<AdminInbox />} />
            <Route path="posts" element={<AdminPosts />} />
            <Route path="posts/:id" element={<AdminPostEditor />} />
            <Route path="reviews" element={<AdminReviews />} />
          </Route>
        </Routes>
      </Suspense>
      <Toaster position="top-right" richColors />
    </BrowserRouter>
  );
}

export default App;
